import { StateSchema } from 'app/config/storeConfig/types';

export const getSelectedEmail = (state: StateSchema): Nullable<string> => state.sendFranchiseSectionModal.selectedEmail;
